var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('EmployeeCountCard',{staticClass:"mr-4 mb-5 mb-lg-0",on:{"card-clicked":_vm.goToEmployee}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }